/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiIntRange } from '../models/ApiIntRange';
import { ApiWaveDecisionsStrategy } from '../models/ApiWaveDecisionsStrategy';
import { ApiWaveScope } from '../models/ApiWaveScope';
import { ApiWaveType } from '../models/ApiWaveType';
import { HttpFile } from '../http/http';

export class ApiWaveConfig {
    'type': ApiWaveType;
    'winning_thresholds': ApiIntRange | null;
    /**
    * This amount of top rated drops will win. Must be set if and only if type is RANK
    */
    'max_winners': number | null;
    /**
    * Vote of a voter is considered eligible after this amount of time after casting it. If not set then votes are eligible immediately after casting.
    */
    'time_lock_ms': number | null;
    'admin_group': ApiWaveScope;
    'authenticated_user_eligible_for_admin': boolean;
    'decisions_strategy': ApiWaveDecisionsStrategy | null;
    'next_decision_time': number | null;
    'admin_drop_deletion_enabled': boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "type",
            "baseName": "type",
            "type": "ApiWaveType",
            "format": ""
        },
        {
            "name": "winning_thresholds",
            "baseName": "winning_thresholds",
            "type": "ApiIntRange",
            "format": ""
        },
        {
            "name": "max_winners",
            "baseName": "max_winners",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "time_lock_ms",
            "baseName": "time_lock_ms",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "admin_group",
            "baseName": "admin_group",
            "type": "ApiWaveScope",
            "format": ""
        },
        {
            "name": "authenticated_user_eligible_for_admin",
            "baseName": "authenticated_user_eligible_for_admin",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "decisions_strategy",
            "baseName": "decisions_strategy",
            "type": "ApiWaveDecisionsStrategy",
            "format": ""
        },
        {
            "name": "next_decision_time",
            "baseName": "next_decision_time",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "admin_drop_deletion_enabled",
            "baseName": "admin_drop_deletion_enabled",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiWaveConfig.attributeTypeMap;
    }

    public constructor() {
    }
}


